/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.ts to modify the generation of this file.




import * as ADFBannerImage from 'src/components/ADFBannerImage';
import * as ADFButton from 'src/components/ADFButton';
import * as ADFCardCarousel from 'src/components/ADFCardCarousel';
import * as ADFCardsWrapper from 'src/components/ADFCardsWrapper';
import * as ADFCareerMatcherHero from 'src/components/ADFCareerMatcherHero';
import * as ADFCategoryHeader from 'src/components/ADFCategoryHeader';
import * as ADFColumnSplitter from 'src/components/ADFColumnSplitter';
import * as ADFContactCTATile from 'src/components/ADFContactCTATile';
import * as ADFContactusForm from 'src/components/ADFContactusForm';
import * as ADFContainer from 'src/components/ADFContainer';
import * as ADFContentBlock from 'src/components/ADFContentBlock';
import * as ADFContentHTML from 'src/components/ADFContentHTML';
import * as ADFCTATile from 'src/components/ADFCTATile';
import * as ADFDrawer from 'src/components/ADFDrawer';
import * as ADFErrorMessage from 'src/components/ADFErrorMessage';
import * as ADFEventCarousel from 'src/components/ADFEventCarousel';
import * as ADFEventDetails from 'src/components/ADFEventDetails';
import * as ADFEventHome from 'src/components/ADFEventHome';
import * as ADFEventSearchResults from 'src/components/ADFEventSearchResults';
import * as ADFFaqCarousel from 'src/components/ADFFaqCarousel';
import * as ADFFaqCollection from 'src/components/ADFFaqCollection';
import * as ADFFaqSearch from 'src/components/ADFFaqSearch';
import * as ADFFaqTopics from 'src/components/ADFFaqTopics';
import * as ADFFeedbackForm from 'src/components/ADFFeedbackForm';
import * as ADFFooter from 'src/components/ADFFooter';
import * as ADFGlobalNotificationBanner from 'src/components/ADFGlobalNotificationBanner';
import * as ADFGlobalSearchResults from 'src/components/ADFGlobalSearchResults';
import * as ADFHeroBanner from 'src/components/ADFHeroBanner';
import * as ADFIconTextList from 'src/components/ADFIconTextList';
import * as ADFImageBlock from 'src/components/ADFImageBlock';
import * as ADFImageText from 'src/components/ADFImageText';
import * as ADFJobCard from 'src/components/ADFJobCard';
import * as ADFJobComparison from 'src/components/ADFJobComparison';
import * as ADFJobDetails from 'src/components/ADFJobDetails';
import * as ADFJobSalaryDetails from 'src/components/ADFJobSalaryDetails';
import * as ADFJobsCategoryCard from 'src/components/ADFJobsCategoryCard';
import * as ADFMapUnitLocator from 'src/components/ADFMapUnitLocator';
import * as ADFNavigation from 'src/components/ADFNavigation';
import * as ADFNavigationAlt from 'src/components/ADFNavigationAlt';
import * as ADFNotification from 'src/components/ADFNotification';
import * as ADFPageTab from 'src/components/ADFPageTab';
import * as ADFProfileTab from 'src/components/ADFProfileTab';
import * as ADFQuickLinks from 'src/components/ADFQuickLinks';
import * as ADFQuoteCarousel from 'src/components/ADFQuoteCarousel';
import * as ADFRankCardList from 'src/components/ADFRankCardList';
import * as ADFRealStoriesCardGrid from 'src/components/ADFRealStoriesCardGrid';
import * as ADFRealStoriesHeader from 'src/components/ADFRealStoriesHeader';
import * as ADFReserveUnitLocator from 'src/components/ADFReserveUnitLocator';
import * as ADFRowSplitter from 'src/components/ADFRowSplitter';
import * as ADFSearchResults from 'src/components/ADFSearchResults';
import * as ADFSectionTab from 'src/components/ADFSectionTab';
import * as ADFSettings from 'src/components/ADFSettings';
import * as ADFSideTab from 'src/components/ADFSideTab';
import * as ADFSimpleCards from 'src/components/ADFSimpleCards';
import * as ADFSitemapNavigation from 'src/components/ADFSitemapNavigation';
import * as ADFSpacer from 'src/components/ADFSpacer';
import * as ADFStoryBanner from 'src/components/ADFStoryBanner';
import * as ADFStoryBannerTab from 'src/components/ADFStoryBannerTab';
import * as ADFStoryItem from 'src/components/ADFStoryItem';
import * as ADFStoryPanel from 'src/components/ADFStoryPanel';
import * as ADFTextContentBlock from 'src/components/ADFTextContentBlock';
import * as ADFWeightedQuestionnaire from 'src/components/ADFWeightedQuestionnaire';
import * as Container from 'src/components/Container';
import * as ContentBlock from 'src/components/ContentBlock';
import * as LinkList from 'src/components/LinkList';
import * as Navigation from 'src/components/Navigation';
import * as PageContent from 'src/components/PageContent';
import * as PartialDesignDynamicPlaceholder from 'src/components/PartialDesignDynamicPlaceholder';
import * as Promo from 'src/components/Promo';
import * as RichText from 'src/components/RichText';
import * as RowSplitter from 'src/components/RowSplitter';
import * as StyleguideAnimatedIcons from 'src/components/StyleguideAnimatedIcons';
import * as Title from 'src/components/Title';
import * as _layoutContext from 'src/components/front-end/_layoutContext';
import * as _LocalNavContext from 'src/components/front-end/_LocalNavContext';
import * as _sharedContext from 'src/components/front-end/_sharedContext';
import * as AudioPlayer from 'src/components/front-end/Audio/AudioPlayer';
import * as AudioPlayerBar from 'src/components/front-end/Audio/AudioPlayerBar';
import * as AudioPlayerBarButtons from 'src/components/front-end/Audio/AudioPlayerBarButtons';
import * as AudioPlayerProgressBar from 'src/components/front-end/Audio/AudioPlayerProgressBar';
import * as AudioPlaytime from 'src/components/front-end/Audio/AudioPlaytime';
import * as AudioTranscript from 'src/components/front-end/Audio/AudioTranscript';
import * as useAudioPlayerProgress from 'src/components/front-end/Audio/useAudioPlayerProgress';
import * as _AudioInterface from 'src/components/front-end/Audio/_AudioInterface';
import * as BreadCrumb from 'src/components/front-end/BreadCrumbs/BreadCrumb';
import * as BreadCrumbLink from 'src/components/front-end/BreadCrumbs/BreadCrumbLink';
import * as BackButton from 'src/components/front-end/Buttons/BackButton';
import * as Button from 'src/components/front-end/Buttons/Button';
import * as ExpandBar from 'src/components/front-end/Buttons/ExpandBar';
import * as Pagination from 'src/components/front-end/Buttons/Pagination';
import * as ProfileButton from 'src/components/front-end/Buttons/ProfileButton';
import * as TabButton from 'src/components/front-end/Buttons/TabButton';
import * as ToggleButton from 'src/components/front-end/Buttons/ToggleButton';
import * as Card from 'src/components/front-end/Cards/Card';
import * as CardContentEvents from 'src/components/front-end/Cards/CardContentEvents';
import * as CardCopy from 'src/components/front-end/Cards/CardCopy';
import * as CardImage from 'src/components/front-end/Cards/CardImage';
import * as ImageCard from 'src/components/front-end/Cards/ImageCard';
import * as ImageOverlayCard from 'src/components/front-end/Cards/ImageOverlayCard';
import * as SimpleCard from 'src/components/front-end/Cards/SimpleCard';
import * as CarouselSwiper from 'src/components/front-end/Carousel/CarouselSwiper';
import * as CarouselSwiperControls from 'src/components/front-end/Carousel/CarouselSwiperControls';
import * as CategoryCard from 'src/components/front-end/CategoryCard/CategoryCard';
import * as ContactCTA from 'src/components/front-end/ContactCTA/ContactCTA';
import * as Preferences from 'src/components/front-end/ContactUs/Preferences';
import * as ContentComponent from 'src/components/front-end/ContentBlock/ContentComponent';
import * as CTATile from 'src/components/front-end/CTATile/CTATile';
import * as CustomSelect from 'src/components/front-end/CustomSelect/CustomSelect';
import * as Drawer from 'src/components/front-end/Drawers/Drawer';
import * as Buttons from 'src/components/front-end/Drawers/drawer-components/Buttons';
import * as Content from 'src/components/front-end/Drawers/drawer-components/Content';
import * as ContentLinks from 'src/components/front-end/Drawers/drawer-components/ContentLinks';
import * as ContentSummary from 'src/components/front-end/Drawers/drawer-components/ContentSummary';
import * as ContentSummaryList from 'src/components/front-end/Drawers/drawer-components/ContentSummaryList';
import * as Divider from 'src/components/front-end/Drawers/drawer-components/Divider';
import * as EntryMethodFilter from 'src/components/front-end/Drawers/drawer-components/EntryMethodFilter';
import * as Feedback from 'src/components/front-end/Drawers/drawer-components/Feedback';
import * as Filter from 'src/components/front-end/Drawers/drawer-components/Filter';
import * as Header from 'src/components/front-end/Drawers/drawer-components/Header';
import * as OptIn from 'src/components/front-end/Drawers/drawer-components/OptIn';
import * as Shortlist from 'src/components/front-end/Drawers/drawer-components/Shortlist';
import * as SmallHeading from 'src/components/front-end/Drawers/drawer-components/SmallHeading';
import * as Toggle from 'src/components/front-end/Drawers/drawer-components/Toggle';
import * as Attendee from 'src/components/front-end/Events/Attendee';
import * as EventCard from 'src/components/front-end/Events/EventCard';
import * as EventDrawer from 'src/components/front-end/Events/EventDrawer';
import * as EventSearchDrawer from 'src/components/front-end/Events/EventSearchDrawer';
import * as FeaturedEventWrapper from 'src/components/front-end/Events/FeaturedEventWrapper';
import * as Guests from 'src/components/front-end/Events/Guests';
import * as LocationDrawer from 'src/components/front-end/Events/LocationDrawer';
import * as RegistrationForm from 'src/components/front-end/Events/RegistrationForm';
import * as AboutSection from 'src/components/front-end/Events/event-details/AboutSection';
import * as ClosedNotification from 'src/components/front-end/Events/event-details/ClosedNotification';
import * as DeliveryAllocated from 'src/components/front-end/Events/event-details/DeliveryAllocated';
import * as DetailsTab from 'src/components/front-end/Events/event-details/DetailsTab';
import * as EventDetailConst from 'src/components/front-end/Events/event-details/EventDetailConst';
import * as EventSummaryCard from 'src/components/front-end/Events/event-details/EventSummaryCard';
import * as LocationTab from 'src/components/front-end/Events/event-details/LocationTab';
import * as RegisterTab from 'src/components/front-end/Events/event-details/RegisterTab';
import * as SimilarEvents from 'src/components/front-end/Events/event-details/SimilarEvents';
import * as FAQBrowser from 'src/components/front-end/FAQ/FAQBrowser';
import * as FAQContent from 'src/components/front-end/FAQ/FAQContent';
import * as FAQContext from 'src/components/front-end/FAQ/FAQContext';
import * as FAQDrawer from 'src/components/front-end/FAQ/FAQDrawer';
import * as FAQFeedback from 'src/components/front-end/FAQ/FAQFeedback';
import * as FAQHelpers from 'src/components/front-end/FAQ/FAQHelpers';
import * as FAQItem from 'src/components/front-end/FAQ/FAQItem';
import * as FAQList from 'src/components/front-end/FAQ/FAQList';
import * as FAQMobileBrowser from 'src/components/front-end/FAQ/FAQMobileBrowser';
import * as FAQReducer from 'src/components/front-end/FAQ/FAQReducer';
import * as FAQSearch from 'src/components/front-end/FAQ/FAQSearch';
import * as FAQSubcategoryItem from 'src/components/front-end/FAQ/FAQSubcategoryItem';
import * as FAQSubcategoryList from 'src/components/front-end/FAQ/FAQSubcategoryList';
import * as FAQTopicList from 'src/components/front-end/FAQ/FAQTopicList';
import * as FAQTypes from 'src/components/front-end/FAQ/FAQTypes';
import * as FormField from 'src/components/front-end/FormFields/FormField';
import * as FormValidation from 'src/components/front-end/FormFields/FormValidation';
import * as Captcha from 'src/components/front-end/Forms/Captcha';
import * as Checkbox from 'src/components/front-end/Forms/Checkbox';
import * as constants from 'src/components/front-end/Forms/constants';
import * as ErrorMessage from 'src/components/front-end/Forms/ErrorMessage';
import * as Fieldset from 'src/components/front-end/Forms/Fieldset';
import * as Form from 'src/components/front-end/Forms/Form';
import * as index from 'src/components/front-end/Forms/index';
import * as Input from 'src/components/front-end/Forms/Input';
import * as Radio from 'src/components/front-end/Forms/Radio';
import * as Select from 'src/components/front-end/Forms/Select';
import * as Submit from 'src/components/front-end/Forms/Submit';
import * as SubmittingOverlay from 'src/components/front-end/Forms/SubmittingOverlay';
import * as SuccessMessage from 'src/components/front-end/Forms/SuccessMessage';
import * as TextArea from 'src/components/front-end/Forms/TextArea';
import * as types from 'src/components/front-end/Forms/types';
import * as Validation from 'src/components/front-end/Forms/Validation';
import * as HeaderActions from 'src/components/front-end/Header/HeaderActions';
import * as NavigationAction from 'src/components/front-end/Header/NavigationAction';
import * as NavigationBackButton from 'src/components/front-end/Header/NavigationBackButton';
import * as NavigationBreadcrumbs from 'src/components/front-end/Header/NavigationBreadcrumbs';
import * as navigationHelpers from 'src/components/front-end/Header/navigationHelpers';
import * as NavigationItem from 'src/components/front-end/Header/NavigationItem';
import * as NavigationItemList from 'src/components/front-end/Header/NavigationItemList';
import * as NavigationMenu from 'src/components/front-end/Header/NavigationMenu';
import * as NavigationProvider from 'src/components/front-end/Header/NavigationProvider';
import * as SiteLogo from 'src/components/front-end/Header/SiteLogo';
import * as SiteNavigation from 'src/components/front-end/Header/SiteNavigation';
import * as icondata from 'src/components/front-end/Icons/icon-data';
import * as Icon from 'src/components/front-end/Icons/Icon';
import * as SvgIcon from 'src/components/front-end/Icons/SvgIcon';
import * as getImagePath from 'src/components/front-end/Images/getImagePath';
import * as ImageLoader from 'src/components/front-end/Images/ImageLoader';
import * as ImageSwiper from 'src/components/front-end/Images/ImageSwiper';
import * as JobCard from 'src/components/front-end/JobCard/JobCard';
import * as CareerSelector from 'src/components/front-end/JobComparison/CareerSelector';
import * as CareerSelectorOptions from 'src/components/front-end/JobComparison/CareerSelectorOptions';
import * as ComparisonTable from 'src/components/front-end/JobComparison/ComparisonTable';
import * as helpers from 'src/components/front-end/JobComparison/helpers';
import * as JobComparisonActions from 'src/components/front-end/JobComparison/JobComparisonActions';
import * as JobComparisonTable from 'src/components/front-end/JobComparison/JobComparisonTable';
import * as useCareerOptions from 'src/components/front-end/JobComparison/useCareerOptions';
import * as contentBuilder from 'src/components/front-end/JobDetails/contentBuilder';
import * as JobCardStats from 'src/components/front-end/JobDetails/JobCardStats';
import * as JobCTATiles from 'src/components/front-end/JobDetails/JobCTATiles';
import * as JobDetails from 'src/components/front-end/JobDetails/JobDetails';
import * as JobLayout from 'src/components/front-end/JobDetails/JobLayout';
import * as JobNextSteps from 'src/components/front-end/JobDetails/JobNextSteps';
import * as JobNotification from 'src/components/front-end/JobDetails/JobNotification';
import * as JobPageHeader from 'src/components/front-end/JobDetails/JobPageHeader';
import * as JobTabButton from 'src/components/front-end/JobDetails/JobTabButton';
import * as JobTabHeader from 'src/components/front-end/JobDetails/JobTabHeader';
import * as JobTabPanel from 'src/components/front-end/JobDetails/JobTabPanel';
import * as JobTheRole from 'src/components/front-end/JobDetails/JobTheRole';
import * as JobWaysToJoin from 'src/components/front-end/JobDetails/JobWaysToJoin';
import * as RelatedJobs from 'src/components/front-end/JobDetails/RelatedJobs';
import * as _JobInterface from 'src/components/front-end/JobDetails/_JobInterface';
import * as KeyInfoPanel from 'src/components/front-end/KeyInfoPanel/KeyInfoPanel';
import * as Label from 'src/components/front-end/Labels/Label';
import * as LabelIcon from 'src/components/front-end/Labels/LabelIcon';
import * as List from 'src/components/front-end/Lists/List';
import * as ListBase from 'src/components/front-end/Lists/ListBase';
import * as ListIcon from 'src/components/front-end/Lists/ListIcon';
import * as ListItem from 'src/components/front-end/Lists/ListItem';
import * as ListLink from 'src/components/front-end/Lists/ListLink';
import * as DynamicLoader from 'src/components/front-end/Map/DynamicLoader';
import * as GoogleMap from 'src/components/front-end/Map/GoogleMap';
import * as mapconfig from 'src/components/front-end/Map/map.config';
import * as maphelpers from 'src/components/front-end/Map/map.helpers';
import * as MapJobDrawer from 'src/components/front-end/Map/MapJobDrawer';
import * as MapLocationList from 'src/components/front-end/Map/MapLocationList';
import * as MapSearchField from 'src/components/front-end/Map/MapSearchField';
import * as MapSearchMatch from 'src/components/front-end/Map/MapSearchMatch';
import * as MainNavAction from 'src/components/front-end/Navigation/MainNavAction';
import * as MainNavBack from 'src/components/front-end/Navigation/MainNavBack';
import * as MainNavCall from 'src/components/front-end/Navigation/MainNavCall';
import * as MainNavIcon from 'src/components/front-end/Navigation/MainNavIcon';
import * as MainNavItem from 'src/components/front-end/Navigation/MainNavItem';
import * as MainNavMobile from 'src/components/front-end/Navigation/MainNavMobile';
import * as MainNavSubItem from 'src/components/front-end/Navigation/MainNavSubItem';
import * as SideNav from 'src/components/front-end/Navigation/SideNav';
import * as SideNavTab from 'src/components/front-end/Navigation/SideNavTab';
import * as SideNavTabBar from 'src/components/front-end/Navigation/SideNavTabBar';
import * as _interface from 'src/components/front-end/Navigation/_interface';
import * as InPageNavLink from 'src/components/front-end/NavigationLinks/InPageNavLink';
import * as Notification from 'src/components/front-end/Notifications/Notification';
import * as HeaderImage from 'src/components/front-end/PageHeader/HeaderImage';
import * as PageHeader from 'src/components/front-end/PageHeader/PageHeader';
import * as ProfilePicture from 'src/components/front-end/ProfileTab/ProfilePicture';
import * as ProfileTab from 'src/components/front-end/ProfileTab/ProfileTab';
import * as ProfileTabWrapper from 'src/components/front-end/ProfileTab/ProfileTabWrapper';
import * as _ProfileTabInterface from 'src/components/front-end/ProfileTab/_ProfileTabInterface';
import * as Questionnaire from 'src/components/front-end/Questionnaire/Questionnaire';
import * as QuickLink from 'src/components/front-end/QuickLinks/QuickLink';
import * as QuoteAudioCarousel from 'src/components/front-end/QuoteCarousel/QuoteAudioCarousel';
import * as QuoteImageCarousel from 'src/components/front-end/QuoteCarousel/QuoteImageCarousel';
import * as QuoteSlideAudio from 'src/components/front-end/QuoteCarousel/QuoteSlideAudio';
import * as QuoteSlideImage from 'src/components/front-end/QuoteCarousel/QuoteSlideImage';
import * as QuoteSlideText from 'src/components/front-end/QuoteCarousel/QuoteSlideText';
import * as QuoteTextCarousel from 'src/components/front-end/QuoteCarousel/QuoteTextCarousel';
import * as ReCaptcha from 'src/components/front-end/ReCaptcha/ReCaptcha';
import * as SearchDrawer from 'src/components/front-end/Search/SearchDrawer';
import * as SearchField from 'src/components/front-end/Search/SearchField';
import * as SearchInput from 'src/components/front-end/Search/SearchInput';
import * as SearchInputResults from 'src/components/front-end/Search/SearchInputResults';
import * as SearchMatch from 'src/components/front-end/Search/SearchMatch';
import * as SearchNoResults from 'src/components/front-end/Search/SearchNoResults';
import * as SearchTakeover from 'src/components/front-end/Search/SearchTakeover';
import * as SearchTypes from 'src/components/front-end/Search/SearchTypes';
import * as ShareButtons from 'src/components/front-end/ShareButtons/ShareButtons';
import * as GridTest from 'src/components/front-end/Shared/GridTest';
import * as Utils from 'src/components/front-end/Shared/Utils';
import * as ShortlistButton from 'src/components/front-end/Shortlist/ShortlistButton';
import * as ShortlistNavAction from 'src/components/front-end/Shortlist/ShortlistNavAction';
import * as ShortlistProvider from 'src/components/front-end/Shortlist/ShortlistProvider';
import * as InfoPanel from 'src/components/front-end/SitecoreHelpers/InfoPanel';
import * as Metadata from 'src/components/front-end/SiteMetadata/Metadata';
import * as Spacer from 'src/components/front-end/Spacer/Spacer';
import * as CareerCardPanel from 'src/components/front-end/StoryPanel/CareerCardPanel';
import * as CopyPanel from 'src/components/front-end/StoryPanel/CopyPanel';
import * as ListPanel from 'src/components/front-end/StoryPanel/ListPanel';
import * as MediaImagePanel from 'src/components/front-end/StoryPanel/MediaImagePanel';
import * as MediaVideoPanel from 'src/components/front-end/StoryPanel/MediaVideoPanel';
import * as QuotePanel from 'src/components/front-end/StoryPanel/QuotePanel';
import * as StandardPanel from 'src/components/front-end/StoryPanel/StandardPanel';
import * as StatementPanel from 'src/components/front-end/StoryPanel/StatementPanel';
import * as StatsPanel from 'src/components/front-end/StoryPanel/StatsPanel';
import * as StoryBanner from 'src/components/front-end/StoryPanel/StoryBanner';
import * as StoryLaunch from 'src/components/front-end/StoryPanel/StoryLaunch';
import * as StorySlide from 'src/components/front-end/StoryPanel/StorySlide';
import * as StorySwiper from 'src/components/front-end/StoryPanel/StorySwiper';
import * as StoryTakeover from 'src/components/front-end/StoryPanel/StoryTakeover';
import * as ThumbnailPanel from 'src/components/front-end/StoryPanel/ThumbnailPanel';
import * as TitlePanel from 'src/components/front-end/StoryPanel/TitlePanel';
import * as SummaryInfo from 'src/components/front-end/SummaryInfo/SummaryInfo';
import * as PageTab from 'src/components/front-end/Tabs/PageTab';
import * as SectionTabs from 'src/components/front-end/Tabs/SectionTabs';
import * as Tab from 'src/components/front-end/Tabs/Tab';
import * as TabBar from 'src/components/front-end/Tabs/TabBar';
import * as tabDependencies from 'src/components/front-end/Tabs/tabDependencies';
import * as TabSwiper from 'src/components/front-end/Tabs/TabSwiper';
import * as DateTag from 'src/components/front-end/Tags/DateTag';
import * as FilterTag from 'src/components/front-end/Tags/FilterTag';
import * as ServiceTag from 'src/components/front-end/Tags/ServiceTag';
import * as StandardTag from 'src/components/front-end/Tags/StandardTag';
import * as StandardTagList from 'src/components/front-end/Tags/StandardTagList';
import * as HeaderText from 'src/components/front-end/TextBlocks/HeaderText';
import * as LedeText from 'src/components/front-end/TextBlocks/LedeText';
import * as QuoteText from 'src/components/front-end/TextBlocks/QuoteText';
import * as StandardText from 'src/components/front-end/TextBlocks/StandardText';
import * as StatementText from 'src/components/front-end/TextBlocks/StatementText';
import * as StatText from 'src/components/front-end/TextBlocks/StatText';
import * as TitleText from 'src/components/front-end/TextBlocks/TitleText';
import * as TwIndicator from 'src/components/front-end/Utility/TwIndicator';
import * as VideoBanner from 'src/components/front-end/Video/VideoBanner';
import * as VideoModal from 'src/components/front-end/Video/VideoModal';
import * as WeightedQuestionnaire from 'src/components/front-end/WeightedQuestionnaire/WeightedQuestionnaire';
import * as weightedQuestionnaireHelpers from 'src/components/front-end/WeightedQuestionnaire/weightedQuestionnaireHelpers';
import * as WeightedQuestionnaireQuestion from 'src/components/front-end/WeightedQuestionnaire/WeightedQuestionnaireQuestion';
import * as WeightedQuestionnaireResult from 'src/components/front-end/WeightedQuestionnaire/WeightedQuestionnaireResult';
import * as WeightedQuestionnaireResultsCarousel from 'src/components/front-end/WeightedQuestionnaire/WeightedQuestionnaireResultsCarousel';

const components = new Map();

components.set('ADFBannerImage', ADFBannerImage);
components.set('ADFButton', ADFButton);
components.set('ADFCardCarousel', ADFCardCarousel);
components.set('ADFCardsWrapper', ADFCardsWrapper);
components.set('ADFCareerMatcherHero', ADFCareerMatcherHero);
components.set('ADFCategoryHeader', ADFCategoryHeader);
components.set('ADFColumnSplitter', ADFColumnSplitter);
components.set('ADFContactCTATile', ADFContactCTATile);
components.set('ADFContactusForm', ADFContactusForm);
components.set('ADFContainer', ADFContainer);
components.set('ADFContentBlock', ADFContentBlock);
components.set('ADFContentHTML', ADFContentHTML);
components.set('ADFCTATile', ADFCTATile);
components.set('ADFDrawer', ADFDrawer);
components.set('ADFErrorMessage', ADFErrorMessage);
components.set('ADFEventCarousel', ADFEventCarousel);
components.set('ADFEventDetails', ADFEventDetails);
components.set('ADFEventHome', ADFEventHome);
components.set('ADFEventSearchResults', ADFEventSearchResults);
components.set('ADFFaqCarousel', ADFFaqCarousel);
components.set('ADFFaqCollection', ADFFaqCollection);
components.set('ADFFaqSearch', ADFFaqSearch);
components.set('ADFFaqTopics', ADFFaqTopics);
components.set('ADFFeedbackForm', ADFFeedbackForm);
components.set('ADFFooter', ADFFooter);
components.set('ADFGlobalNotificationBanner', ADFGlobalNotificationBanner);
components.set('ADFGlobalSearchResults', ADFGlobalSearchResults);
components.set('ADFHeroBanner', ADFHeroBanner);
components.set('ADFIconTextList', ADFIconTextList);
components.set('ADFImageBlock', ADFImageBlock);
components.set('ADFImageText', ADFImageText);
components.set('ADFJobCard', ADFJobCard);
components.set('ADFJobComparison', ADFJobComparison);
components.set('ADFJobDetails', ADFJobDetails);
components.set('ADFJobSalaryDetails', ADFJobSalaryDetails);
components.set('ADFJobsCategoryCard', ADFJobsCategoryCard);
components.set('ADFMapUnitLocator', ADFMapUnitLocator);
components.set('ADFNavigation', ADFNavigation);
components.set('ADFNavigationAlt', ADFNavigationAlt);
components.set('ADFNotification', ADFNotification);
components.set('ADFPageTab', ADFPageTab);
components.set('ADFProfileTab', ADFProfileTab);
components.set('ADFQuickLinks', ADFQuickLinks);
components.set('ADFQuoteCarousel', ADFQuoteCarousel);
components.set('ADFRankCardList', ADFRankCardList);
components.set('ADFRealStoriesCardGrid', ADFRealStoriesCardGrid);
components.set('ADFRealStoriesHeader', ADFRealStoriesHeader);
components.set('ADFReserveUnitLocator', ADFReserveUnitLocator);
components.set('ADFRowSplitter', ADFRowSplitter);
components.set('ADFSearchResults', ADFSearchResults);
components.set('ADFSectionTab', ADFSectionTab);
components.set('ADFSettings', ADFSettings);
components.set('ADFSideTab', ADFSideTab);
components.set('ADFSimpleCards', ADFSimpleCards);
components.set('ADFSitemapNavigation', ADFSitemapNavigation);
components.set('ADFSpacer', ADFSpacer);
components.set('ADFStoryBanner', ADFStoryBanner);
components.set('ADFStoryBannerTab', ADFStoryBannerTab);
components.set('ADFStoryItem', ADFStoryItem);
components.set('ADFStoryPanel', ADFStoryPanel);
components.set('ADFTextContentBlock', ADFTextContentBlock);
components.set('ADFWeightedQuestionnaire', ADFWeightedQuestionnaire);
components.set('Container', Container);
components.set('ContentBlock', ContentBlock);
components.set('LinkList', LinkList);
components.set('Navigation', Navigation);
components.set('PageContent', PageContent);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('Promo', Promo);
components.set('RichText', RichText);
components.set('RowSplitter', RowSplitter);
components.set('StyleguideAnimatedIcons', StyleguideAnimatedIcons);
components.set('Title', Title);
components.set('_layoutContext', _layoutContext);
components.set('_LocalNavContext', _LocalNavContext);
components.set('_sharedContext', _sharedContext);
components.set('AudioPlayer', AudioPlayer);
components.set('AudioPlayerBar', AudioPlayerBar);
components.set('AudioPlayerBarButtons', AudioPlayerBarButtons);
components.set('AudioPlayerProgressBar', AudioPlayerProgressBar);
components.set('AudioPlaytime', AudioPlaytime);
components.set('AudioTranscript', AudioTranscript);
components.set('useAudioPlayerProgress', useAudioPlayerProgress);
components.set('_AudioInterface', _AudioInterface);
components.set('BreadCrumb', BreadCrumb);
components.set('BreadCrumbLink', BreadCrumbLink);
components.set('BackButton', BackButton);
components.set('Button', Button);
components.set('ExpandBar', ExpandBar);
components.set('Pagination', Pagination);
components.set('ProfileButton', ProfileButton);
components.set('TabButton', TabButton);
components.set('ToggleButton', ToggleButton);
components.set('Card', Card);
components.set('CardContentEvents', CardContentEvents);
components.set('CardCopy', CardCopy);
components.set('CardImage', CardImage);
components.set('ImageCard', ImageCard);
components.set('ImageOverlayCard', ImageOverlayCard);
components.set('SimpleCard', SimpleCard);
components.set('CarouselSwiper', CarouselSwiper);
components.set('CarouselSwiperControls', CarouselSwiperControls);
components.set('CategoryCard', CategoryCard);
components.set('ContactCTA', ContactCTA);
components.set('Preferences', Preferences);
components.set('ContentComponent', ContentComponent);
components.set('CTATile', CTATile);
components.set('CustomSelect', CustomSelect);
components.set('Drawer', Drawer);
components.set('Buttons', Buttons);
components.set('Content', Content);
components.set('ContentLinks', ContentLinks);
components.set('ContentSummary', ContentSummary);
components.set('ContentSummaryList', ContentSummaryList);
components.set('Divider', Divider);
components.set('EntryMethodFilter', EntryMethodFilter);
components.set('Feedback', Feedback);
components.set('Filter', Filter);
components.set('Header', Header);
components.set('OptIn', OptIn);
components.set('Shortlist', Shortlist);
components.set('SmallHeading', SmallHeading);
components.set('Toggle', Toggle);
components.set('Attendee', Attendee);
components.set('EventCard', EventCard);
components.set('EventDrawer', EventDrawer);
components.set('EventSearchDrawer', EventSearchDrawer);
components.set('FeaturedEventWrapper', FeaturedEventWrapper);
components.set('Guests', Guests);
components.set('LocationDrawer', LocationDrawer);
components.set('RegistrationForm', RegistrationForm);
components.set('AboutSection', AboutSection);
components.set('ClosedNotification', ClosedNotification);
components.set('DeliveryAllocated', DeliveryAllocated);
components.set('DetailsTab', DetailsTab);
components.set('EventDetailConst', EventDetailConst);
components.set('EventSummaryCard', EventSummaryCard);
components.set('LocationTab', LocationTab);
components.set('RegisterTab', RegisterTab);
components.set('SimilarEvents', SimilarEvents);
components.set('FAQBrowser', FAQBrowser);
components.set('FAQContent', FAQContent);
components.set('FAQContext', FAQContext);
components.set('FAQDrawer', FAQDrawer);
components.set('FAQFeedback', FAQFeedback);
components.set('FAQHelpers', FAQHelpers);
components.set('FAQItem', FAQItem);
components.set('FAQList', FAQList);
components.set('FAQMobileBrowser', FAQMobileBrowser);
components.set('FAQReducer', FAQReducer);
components.set('FAQSearch', FAQSearch);
components.set('FAQSubcategoryItem', FAQSubcategoryItem);
components.set('FAQSubcategoryList', FAQSubcategoryList);
components.set('FAQTopicList', FAQTopicList);
components.set('FAQTypes', FAQTypes);
components.set('FormField', FormField);
components.set('FormValidation', FormValidation);
components.set('Captcha', Captcha);
components.set('Checkbox', Checkbox);
components.set('constants', constants);
components.set('ErrorMessage', ErrorMessage);
components.set('Fieldset', Fieldset);
components.set('Form', Form);
components.set('index', index);
components.set('Input', Input);
components.set('Radio', Radio);
components.set('Select', Select);
components.set('Submit', Submit);
components.set('SubmittingOverlay', SubmittingOverlay);
components.set('SuccessMessage', SuccessMessage);
components.set('TextArea', TextArea);
components.set('types', types);
components.set('Validation', Validation);
components.set('HeaderActions', HeaderActions);
components.set('NavigationAction', NavigationAction);
components.set('NavigationBackButton', NavigationBackButton);
components.set('NavigationBreadcrumbs', NavigationBreadcrumbs);
components.set('navigationHelpers', navigationHelpers);
components.set('NavigationItem', NavigationItem);
components.set('NavigationItemList', NavigationItemList);
components.set('NavigationMenu', NavigationMenu);
components.set('NavigationProvider', NavigationProvider);
components.set('SiteLogo', SiteLogo);
components.set('SiteNavigation', SiteNavigation);
components.set('icon-data', icondata);
components.set('Icon', Icon);
components.set('SvgIcon', SvgIcon);
components.set('getImagePath', getImagePath);
components.set('ImageLoader', ImageLoader);
components.set('ImageSwiper', ImageSwiper);
components.set('JobCard', JobCard);
components.set('CareerSelector', CareerSelector);
components.set('CareerSelectorOptions', CareerSelectorOptions);
components.set('ComparisonTable', ComparisonTable);
components.set('helpers', helpers);
components.set('JobComparisonActions', JobComparisonActions);
components.set('JobComparisonTable', JobComparisonTable);
components.set('useCareerOptions', useCareerOptions);
components.set('contentBuilder', contentBuilder);
components.set('JobCardStats', JobCardStats);
components.set('JobCTATiles', JobCTATiles);
components.set('JobDetails', JobDetails);
components.set('JobLayout', JobLayout);
components.set('JobNextSteps', JobNextSteps);
components.set('JobNotification', JobNotification);
components.set('JobPageHeader', JobPageHeader);
components.set('JobTabButton', JobTabButton);
components.set('JobTabHeader', JobTabHeader);
components.set('JobTabPanel', JobTabPanel);
components.set('JobTheRole', JobTheRole);
components.set('JobWaysToJoin', JobWaysToJoin);
components.set('RelatedJobs', RelatedJobs);
components.set('_JobInterface', _JobInterface);
components.set('KeyInfoPanel', KeyInfoPanel);
components.set('Label', Label);
components.set('LabelIcon', LabelIcon);
components.set('List', List);
components.set('ListBase', ListBase);
components.set('ListIcon', ListIcon);
components.set('ListItem', ListItem);
components.set('ListLink', ListLink);
components.set('DynamicLoader', DynamicLoader);
components.set('GoogleMap', GoogleMap);
components.set('map.config', mapconfig);
components.set('map.helpers', maphelpers);
components.set('MapJobDrawer', MapJobDrawer);
components.set('MapLocationList', MapLocationList);
components.set('MapSearchField', MapSearchField);
components.set('MapSearchMatch', MapSearchMatch);
components.set('MainNavAction', MainNavAction);
components.set('MainNavBack', MainNavBack);
components.set('MainNavCall', MainNavCall);
components.set('MainNavIcon', MainNavIcon);
components.set('MainNavItem', MainNavItem);
components.set('MainNavMobile', MainNavMobile);
components.set('MainNavSubItem', MainNavSubItem);
components.set('SideNav', SideNav);
components.set('SideNavTab', SideNavTab);
components.set('SideNavTabBar', SideNavTabBar);
components.set('_interface', _interface);
components.set('InPageNavLink', InPageNavLink);
components.set('Notification', Notification);
components.set('HeaderImage', HeaderImage);
components.set('PageHeader', PageHeader);
components.set('ProfilePicture', ProfilePicture);
components.set('ProfileTab', ProfileTab);
components.set('ProfileTabWrapper', ProfileTabWrapper);
components.set('_ProfileTabInterface', _ProfileTabInterface);
components.set('Questionnaire', Questionnaire);
components.set('QuickLink', QuickLink);
components.set('QuoteAudioCarousel', QuoteAudioCarousel);
components.set('QuoteImageCarousel', QuoteImageCarousel);
components.set('QuoteSlideAudio', QuoteSlideAudio);
components.set('QuoteSlideImage', QuoteSlideImage);
components.set('QuoteSlideText', QuoteSlideText);
components.set('QuoteTextCarousel', QuoteTextCarousel);
components.set('ReCaptcha', ReCaptcha);
components.set('SearchDrawer', SearchDrawer);
components.set('SearchField', SearchField);
components.set('SearchInput', SearchInput);
components.set('SearchInputResults', SearchInputResults);
components.set('SearchMatch', SearchMatch);
components.set('SearchNoResults', SearchNoResults);
components.set('SearchTakeover', SearchTakeover);
components.set('SearchTypes', SearchTypes);
components.set('ShareButtons', ShareButtons);
components.set('GridTest', GridTest);
components.set('Utils', Utils);
components.set('ShortlistButton', ShortlistButton);
components.set('ShortlistNavAction', ShortlistNavAction);
components.set('ShortlistProvider', ShortlistProvider);
components.set('InfoPanel', InfoPanel);
components.set('Metadata', Metadata);
components.set('Spacer', Spacer);
components.set('CareerCardPanel', CareerCardPanel);
components.set('CopyPanel', CopyPanel);
components.set('ListPanel', ListPanel);
components.set('MediaImagePanel', MediaImagePanel);
components.set('MediaVideoPanel', MediaVideoPanel);
components.set('QuotePanel', QuotePanel);
components.set('StandardPanel', StandardPanel);
components.set('StatementPanel', StatementPanel);
components.set('StatsPanel', StatsPanel);
components.set('StoryBanner', StoryBanner);
components.set('StoryLaunch', StoryLaunch);
components.set('StorySlide', StorySlide);
components.set('StorySwiper', StorySwiper);
components.set('StoryTakeover', StoryTakeover);
components.set('ThumbnailPanel', ThumbnailPanel);
components.set('TitlePanel', TitlePanel);
components.set('SummaryInfo', SummaryInfo);
components.set('PageTab', PageTab);
components.set('SectionTabs', SectionTabs);
components.set('Tab', Tab);
components.set('TabBar', TabBar);
components.set('tabDependencies', tabDependencies);
components.set('TabSwiper', TabSwiper);
components.set('DateTag', DateTag);
components.set('FilterTag', FilterTag);
components.set('ServiceTag', ServiceTag);
components.set('StandardTag', StandardTag);
components.set('StandardTagList', StandardTagList);
components.set('HeaderText', HeaderText);
components.set('LedeText', LedeText);
components.set('QuoteText', QuoteText);
components.set('StandardText', StandardText);
components.set('StatementText', StatementText);
components.set('StatText', StatText);
components.set('TitleText', TitleText);
components.set('TwIndicator', TwIndicator);
components.set('VideoBanner', VideoBanner);
components.set('VideoModal', VideoModal);
components.set('WeightedQuestionnaire', WeightedQuestionnaire);
components.set('weightedQuestionnaireHelpers', weightedQuestionnaireHelpers);
components.set('WeightedQuestionnaireQuestion', WeightedQuestionnaireQuestion);
components.set('WeightedQuestionnaireResult', WeightedQuestionnaireResult);
components.set('WeightedQuestionnaireResultsCarousel', WeightedQuestionnaireResultsCarousel);

// Next.js 'dynamic' import and JavaScript 'dynamic' import are different.
// Next.js 'dynamic(...)' returns common 'React.ComponentType' while
// 'import('...')' returns 'Promise' that will resolve module.
// componentModule uses 'import(...)' because primary usage of it to get not only 'React Component' (default export) but all named exports.
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#dynamic_imports
// componentFactory uses 'dynamic(...)' because primary usage of it to render 'React Component' (default export).
// See https://nextjs.org/docs/advanced-features/dynamic-import
// At the end you will have single preloaded script for each lazy loading module.
// Editing mode doesn't work well with dynamic components in nextjs: dynamic components are not displayed without refresh after a rendering is added. 
// This happens beacuse Sitecore editors simply insert updated HTML generated on server side. This conflicts with nextjs dynamic logic as no HTML gets rendered for dynamic component
// So we use require() to obtain dynamic components in editing mode while preserving dynamic logic for non-editing scenarios
// As we need to be able to seamlessly work with dynamic components in both editing and normal modes, different componentFactory functions will be passed to app

export function componentModule(componentName: string) {
  const component = components.get(componentName);

  // check that component is lazy loading module
  if (!component?.default && component?.module) {
    // return js dynamic import
    return component.module();
  }

  return component;
}

function baseComponentFactory(componentName: string, exportName?: string, isEditing?: boolean) {
  const DEFAULT_EXPORT_NAME = 'Default';
  const component = components.get(componentName);

  // check that component should be dynamically imported
  if (component?.element) {
    // return next.js dynamic import
    return component.element(isEditing);
  }

  if (exportName && exportName !== DEFAULT_EXPORT_NAME) {
    return component[exportName];
  }

  return component?.Default || component?.default || component;
}
  
export function componentFactory(componentName: string, exportName?: string) {
  return baseComponentFactory(componentName, exportName, false);
}

export function editingComponentFactory(componentName: string, exportName?: string) {
  return baseComponentFactory(componentName, exportName, true);
}
